import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Select, MenuItem, Box, ListItemIcon, ListItemText } from "@mui/material";

const FLAGS = {
	es: "https://flagcdn.com/es.svg",
	en: "https://flagcdn.com/us.svg",
	br: "https://flagcdn.com/br.svg",
};

const LanguageSwitcher = ({ compact = false, tone = "dark" }) => {
	const { i18n } = useTranslation();
	const [language, setLanguage] = useState(i18n.language || "es");

	const handleChange = (event) => {
		const selectedLanguage = event.target.value;
		setLanguage(selectedLanguage);
		i18n.changeLanguage(selectedLanguage);
		localStorage.setItem("i18nextLng", selectedLanguage);
	};

	const isLight = tone === "light";

	/** Cómo se ve el valor ya seleccionado en el input */
	const renderValue = (value) => (
		<Box sx={{ display: "flex", alignItems: "center" }}>
			<img src={FLAGS[value]} alt={value} style={{ width: 20, height: 20 }} />
			{!compact && (
				<Box
					component="span"
					sx={{
						ml: 1,
						fontSize: 14,
						color: isLight ? "#fff" : "text.primary", // ✅ texto según contexto
					}}
				>
					{value === "es" ? "Español" : value === "en" ? "English" : "Português BR"}
				</Box>
			)}
		</Box>
	);

	return (
		<Box sx={{ display: "flex", justifyContent: compact ? "center" : "flex-end" }}>
			<Select
				value={language}
				onChange={handleChange}
				variant="outlined"
				renderValue={renderValue}
				sx={{
					border: "none",
					".MuiOutlinedInput-notchedOutline": { border: "none" },
					minWidth: compact ? 48 : 120,
					"& .MuiSelect-select": { p: compact ? 0 : "8px 14px" },

					// ✅ color del texto + ícono del select (la flechita)
					color: isLight ? "#fff" : "text.primary",
					"& .MuiSelect-icon": { color: isLight ? "#fff" : "text.primary" },

					// opcional: hover suave en sidebar
					...(isLight && {
						"&:hover": { backgroundColor: "rgba(255,255,255,0.06)", borderRadius: "12px" },
					}),
				}}
				MenuProps={{
					PaperProps: {
						sx: {
							borderRadius: 2,
							border: "1px solid",
							borderColor: "divider",
						},
					},
				}}
			>
				{["es", "en", "br"].map((lng) => (
					<MenuItem key={lng} value={lng}>
						<ListItemIcon sx={{ minWidth: 30 }}>
							<img src={FLAGS[lng]} alt={lng} style={{ width: 20, height: 20 }} />
						</ListItemIcon>
						<ListItemText
							primary={lng === "es" ? "Español" : lng === "en" ? "English" : "Português BR"}
						/>
					</MenuItem>
				))}
			</Select>
		</Box>
	);
};

LanguageSwitcher.propTypes = {
	compact: PropTypes.bool,
	tone: PropTypes.oneOf(["dark", "light"]), // ✅ nuevo
};

export default LanguageSwitcher;
